export const VOLUMETRY_TASKS_URL = '/volumetry/task-templates'
export const VOLUMETRY_DEPARTMENTS_URL = '/volumetry/department?&size=-1'
export const VOLUMETRY_FREQUENCIES_URL = '/volumetry/frequency?&size=-1'
export const VOLUMETRY_CATEGORIES_URL = '/volumetry/category?&size=-1'

export const STATE_OPTIONS = [
  {
    label: 'Activ',
    value: 'true'
  },
  {
    label: 'Inactiv',
    value: 'false'
  }
]
